import React from 'react';
import { CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Alert, App, Button, Result, Spin, Typography } from 'antd';
import { useLanguage } from 'src/providers/LanguageProvider';
import api from 'src/services/api';
import { useDispatch } from 'react-redux';
import { setHasW } from 'src/store/generalSlice';
import { useNavigate } from 'react-router';

const { Paragraph, Text } = Typography;

const ResultPageERP = ({ data, setIsFinished }) => {

    const { t } = useLanguage();

    const { employeeCount, b2bWebshopEnabled, selectedProfile, invoiceProfileData } = data;

    const messageApi = App.useApp().message;

    const [loading, setLoading] = React.useState(false);

    const dispatch = useDispatch();

    const [isSuccess, setIsSuccess] = React.useState(false);

    const navigate = useNavigate();

    const [mainLicenseId, setMainLicenseId] = React.useState(null);

    const addChildLicense = async (parentId, subLicenses) => {





        let data = []

        for (let sub of subLicenses) {
            for (let i = 0; i < sub.quantity; i++) {
                data.push({
                    plan: sub.plan,
                    invoiceProfileId: selectedProfile,
                    parentId: parentId,
                })
            }
        }

        setLoading(true);
        try {
            const promises = data.map(d => api.post("/licenses", d));
            await Promise.all(promises);

        } catch (e) {
            messageApi.error(t("PURCHASE_FAILED"));
        } finally {
            setLoading(false);
        }

    }


    const onAddSubscription = async () => {


        let success = false
        let parentId = 0;
        if (!selectedProfile) {
            messageApi.error(t("ERROR_SELECT_INVOICE_PROFILE"));
            return;
        }

        setLoading(true);
        try {
            const result = await api.post("/licenses", {
                plan: 13,
                invoiceProfileId: selectedProfile,
                parentId: 0,
            });

            dispatch(setHasW(true))

            parentId = (result.data.license.license.Id);
            setMainLicenseId(parentId);
            success = true

            messageApi.success(t("PURCHASE_SUCCESS"));
        } catch (e) {
            messageApi.error(t("PURCHASE_FAILED"));
        } finally {
            setLoading(false);
        }

        if (success) {
            let subLicenses = [];

            if (employeeCount && employeeCount > 1) {
                subLicenses.push({
                    plan: 21,
                    quantity: employeeCount
                });
            }

            if (b2bWebshopEnabled) {
                subLicenses.push({
                    plan: 17,
                    quantity: 1
                });
            }

            if (subLicenses.length) {
                await addChildLicense(parentId, subLicenses);
            }


            setIsSuccess(true);
        };

        setIsFinished(true)
    }





    if (isSuccess) {
        return (<>
            <Result
                status="success"
                title={t('SUBSCRIPTION_SUCCESS')}
                subTitle={t('YOUR_SUBSCRIPTION_HAS_BEEN_SUCCESSFULLY_ADDED')}
                extra={[
                    <Button
                        onClick={() => window.location.href = `https://myaccount.parts-soft.eu/w-management/wizard?licenseId=${mainLicenseId}`}
                        type="primary" key="console" >
                        {t('WIZARD_W_INSTALL')}
                    </Button>,
                    <Button key="buy" onClick={() => navigate('/licenses')}>
                        {t('VIEW_LICENSES')}
                    </Button>,

                ]}
            >
            </Result>


            <Alert banner message={t('WIZARD_W_INSTALL_DESC')} type="info" showIcon style={{ marginTop: 16 }} />

        </>)
    }





    return (
        <Spin spinning={loading}>

            <Result
                status="info"
                title={t('VALIDATE_YOUR_SELECTIONS')}
                subTitle={t('PLEASE_REVIEW_YOUR_SELECTIONS_BEFORE_ADDING_SUBSCRIPTION')}
                extra={[
                    <Button onClick={onAddSubscription} type="primary" key="console">
                        {t('ADD_SUBSCRIPTION')}
                    </Button>,

                ]}
            >
                <div className="desc">
                    <Paragraph>
                        <Text
                            strong
                            style={{
                                fontSize: 16,
                            }}
                        >
                            {t('YOUR_SELECTIONS')}
                        </Text>
                    </Paragraph>
                    <Paragraph>
                        <CheckCircleOutlined className="site-result-demo-error-icon" /> {t('YOUR_INVOICE_WILL_BE_ISSUED_TO_THIS_ADDRESS') + ' : '} <Typography.Text>{invoiceProfileData?.CompanyName}</Typography.Text>
                    </Paragraph>
                    <Paragraph>
                        <CheckCircleOutlined className="site-result-demo-error-icon" /> {t('NUMBER_OF_EMPLOYEES') + ' : '} <Typography.Text>{employeeCount}</Typography.Text>
                    </Paragraph>
                    <Paragraph>
                        <CheckCircleOutlined className="site-result-demo-error-icon" /> {t('B2B_WEBSHOP_ENABLED') + ' : '} <Typography.Text>{b2bWebshopEnabled ? t('YES') : t('NO')}</Typography.Text>
                    </Paragraph>
                    <Paragraph>
                        <InfoCircleOutlined className="site-result-demo-error-icon" /> {t('YOU_CAN_CHANGE_ALL_OF_THESE_SETTINGS_LATER')}
                    </Paragraph>

                </div>
            </Result>

        </Spin>
    )
}

export default ResultPageERP